"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GIT_COMMIT = exports.GIT_BRANCH = exports.PACKAGE_VERSION = exports.PACKAGE_NAME = exports.BUILD_DATE = void 0;
// This file is auto-generated by the build system.
exports.BUILD_DATE = "Tue, 19 Jan 2021 20:22:51 GMT";
exports.PACKAGE_NAME = "html-living-framework";
exports.PACKAGE_VERSION = "1.0.0-rc1";
exports.GIT_BRANCH = "develop";
exports.GIT_COMMIT = "c7a684d8b78bbda9ca28e64fc099f9bc047878f5";
//# sourceMappingURL=version.js.map